import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const pastOrdersApi = process.env.REACT_APP_PastOrdersApiUrl;

const headers: {
    [key: string]: string;
} = {
    'Content-Type': 'application/json',
};

export const startSyncCounters = (businessUnitIdOrKey: string) => {
    const uniqueId = uuidv4();
    return axios.post(
        `${pastOrdersApi}/v1/api/counters/${businessUnitIdOrKey}/${uniqueId}/start`,
        null,
        { headers }
    );
};

export const postReason = (businessUnitIdOrKey: string, reason: number) => {
    return axios.post(
        `${pastOrdersApi}/v1/api/counters/${businessUnitIdOrKey}/reason`,
        { reason },
        { headers }
    );
};

export const getStatus = (businessUnitIdOrKey: string) => {
    return axios.get(
        `${pastOrdersApi}/v1/api/counters/${businessUnitIdOrKey}/status`,
        { headers }
    );
};
